import {
	type Action,
	createContainer,
	createStore,
	createHook,
} from '@atlassian/react-sweet-state';

type StandupTimerState = {
	started: boolean;
	paused: boolean;
	soundOn: boolean;
	totalSeconds: number;
	elapsedSeconds: number;
};

const initialState: StandupTimerState = {
	soundOn: true,
	started: false,
	paused: false,
	totalSeconds: 120,
	elapsedSeconds: 0,
};

const resetElapsedSeconds =
	(): Action<StandupTimerState> =>
	({ setState, getState }) => {
		setState({
			...getState(),
			elapsedSeconds: 0,
		});
	};

const setTotalSeconds =
	(totalSeconds: number): Action<StandupTimerState> =>
	({ setState, getState }) => {
		setState({
			...getState(),
			totalSeconds,
		});
	};

const incrementElapsedSeconds =
	(): Action<StandupTimerState> =>
	({ setState, getState }) =>
		setState({
			...getState(),
			elapsedSeconds: getState().elapsedSeconds + 1,
		});

const startTimer =
	(): Action<StandupTimerState> =>
	({ setState, getState }) =>
		setState({ ...getState(), started: true });

const pauseTimer =
	({ elapsed }: { elapsed: number }): Action<StandupTimerState> =>
	({ setState, getState }) =>
		setState({ ...getState(), started: false, elapsedSeconds: elapsed });

const stopTimer =
	(): Action<StandupTimerState> =>
	({ setState, getState }) =>
		setState({
			...getState(),
			started: false,
			elapsedSeconds: 0,
		});

const actions = {
	resetElapsedSeconds,
	setTotalSeconds,
	incrementElapsedSeconds,
	startTimer,
	stopTimer,
	pauseTimer,
};

export const StandupTimerStoreContainer = createContainer();

const standupTimerStore = createStore({
	name: 'JiraRitualsStandupTimerStore',
	initialState,
	actions,
	containedBy: StandupTimerStoreContainer,
});

export const useStandupTimerStore = createHook(standupTimerStore);
